<template>
  <div class="content">
    <div class="header">
      <div></div>
      <div class="header-title">{{ title }}</div>
      <div v-if="dataForm ? dataForm.Status && dataForm.Status === '1' : false" class="header-status status1">设备在线</div>
      <div v-else class="header-status status2">设备离线</div>
    </div>
    <div class="container">
      <div class="item">
        <div v-if="title === '浆水池固含量监测'" class="headTitle">固含量(%)</div>
        <div v-else class="headTitle">液位仪库存(吨)</div>
        <div class="num">
          <span v-if="title === '浆水池固含量监测'">{{ dataForm ? dataForm.guhanliang || "" : "" }}</span>
          <span v-else>{{ dataForm ? (dataForm.H ? (dataForm.H / 1000).toFixed(2) : "") : "" }}</span>
        </div>
      </div>
    </div>
    <div class="time">最后数据更新于{{ dataForm ? dataForm._terminalTime || "" : "" }}</div>
  </div>
</template>

<script>
export default {
  props: ["title", "dataInfo"],
  data() {
    return {
      // title: '料仓环境监测',
      status: "设备在线",
      dataForm: null,
    };
  },
  watch: {
    dataInfo(val) {
      this.dataForm = val;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
}
.header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;

  &-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  &-status {
    font-size: 16px;
    font-weight: bold;
    text-align: right;
  }
  div {
    width: 33.33%;
  }
  .status1 {
    color: #67c23a;
  }
  .status2 {
    color: #f56c6c;
  }
}
.container {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .item {
    width: 50%;
    display: flex;
    justify-content: space-between;
    .headTitle {
      width: 50%;
      font-size: 18px;
      text-align: right;
      padding-right: 50px;
    }
    .num {
      width: 50%;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      padding-left: 50px;
    }
  }
}
.time {
  text-align: center;
}
</style>